import React from 'react';
import { Node, mergeAttributes } from '@tiptap/core';
import { NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import CloseIcon from '@material-ui/icons/Close';

// UI Component (Rendered inside Tiptap Editor)
const LinkPreviewComponent = ({ node, deleteNode }) => {
  const { url, title, description, image } = node.attrs;

  return (
    <NodeViewWrapper className="link-preview-node-wrapper">
      <span
        className="closeIcon"
        onClick={(e) => {
          e.stopPropagation();
          deleteNode();
        }}
        title="Remove preview"
      >
        <CloseIcon style={{ fontSize: 16 }} />
      </span>

      {/* CARD */}
      <div className="link-preview-card">
        {image && (
          <img
            src={image}
            alt=""
            className="link-preview-image"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        )}

        <div className="link-preview-content">
          <div className="link-preview-title" title={title || url}>
            {title || url}
          </div>

          {description && (
            <div className="link-preview-description" title={description}>
              {description}
            </div>
          )}

          <div className="link-preview-url">{url}</div>
        </div>
      </div>
    </NodeViewWrapper>
  );
};

/* ==========================================================================
   Tiptap Extension
========================================================================== */
export const LinkPreview = Node.create({
  name: 'linkPreview',

  group: 'block',
  atom: true,
  isolating: true,
  selectable: true,

  addAttributes() {
    return {
      url: { default: '' },
      title: { default: '' },
      description: { default: '' },
      image: { default: '' },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'a[url]',
        priority: 1000,
        getAttrs: (el) => ({
          url: el.getAttribute('url') || el.getAttribute('href') || '',
          title: el.getAttribute('title') || '',
          description: el.getAttribute('description') || '',
          image: el.getAttribute('image') || '',
        }),
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const { url, title, description, image } = node.attrs;

    return [
      'a',
      mergeAttributes(HTMLAttributes, {
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer',
        url,
        title,
        description,
        image,
        style:
          'display:flex;align-items:center;border:1px solid #e1dfdd;border-radius:8px;overflow:hidden;background:#fff;text-decoration:none;color:inherit;max-width:440px;margin:6px 0;',
      }),

      ...(image
        ? [
            [
              'img',
              {
                src: image,
                style: 'width:90px;height:90px;object-fit:cover;flex-shrink:0;',
              },
            ],
          ]
        : []),

      [
        'div',
        {
          style:
            'padding:8px 12px;display:flex;flex-direction:column;flex:1;min-width:0;overflow:hidden;',
        },

        [
          'div',
          {
            style:
              'font-size:13px;color:#1976d2;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;',
          },
          title || url,
        ],

        ...(description
          ? [
              [
                'div',
                {
                  style:
                    'font-size:12px;color:#605e5c;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;margin-top:2px;line-height:1.3;',
                },
                description,
              ],
            ]
          : []),

        [
          'div',
          {
            style:
              'font-size:11px;color:#1976d2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:4px;',
          },
          url,
        ],
      ],
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(LinkPreviewComponent);
  },
});
